import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { catchError, finalize, of } from 'rxjs';
import { ContractDetailDto, PropertyListingDto, RoleDto, SellMyPropertyDto, UserDto } from '../../../../../../app/services/property-matrixV2/models';
import { LookupService, PropertyListingService, UserManagementService } from '../../../../../../app/services/property-matrixV2/services';
import { ListingStateService } from '../../../../../../app/shared/services/listing-state-service/listing-state.service';
import { NotificationService } from '../../../../../../app/shared/services/notification-service/notification.service';

@Component({
  selector: 'app-listing-users',
  templateUrl: './listing-users.component.html',
  styleUrls: ['./listing-users.component.scss']
})
export class ListingUsersComponent implements OnInit {
  displayedColumns: string[] = ['fullName', 'profession', 'email', 'status', 'action'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() selectedListing: PropertyListingDto;
  dataSource: MatTableDataSource<any>;
  loading = false;
  Users: any[] = [];
  roles: RoleDto[] = [];
  listingId: string | null = null;

  constructor(
    private listingService: PropertyListingService,
    private listingStateService: ListingStateService,
    private lookupService: LookupService,
    private notificationService: NotificationService,
    private userManagementService: UserManagementService,
  ) { }

  ngOnInit(): void {
    this.userManagementService.apiV1UserManagementGetRolesGet().subscribe(result => {
      this.roles = result;
      this.listingStateService.selectedListing$.subscribe({
        next: (listing: PropertyListingDto) => {
          if (listing) {
            this.selectedListing = listing;

            this.listingService.apiV1PropertyListingGetPropertyListingByIdGet({ listingId: this.selectedListing.id }).subscribe(result => {
              this.selectedListing = result;
              this.getUsers();
            });
          }
        }
      });
    });
  }

  getUsers() {
    if (this.selectedListing && this.selectedListing.taskList) {
      this.Users = [];

      this.selectedListing.taskList.forEach(task => {
        if (!task.user) {
          return;
        }

        const thisTaskStatus = task.userStatusText != null ? task.userStatusText : task.comment;
        const existingUser = this.Users.find(u => u.id === task.user.id);

        if (!existingUser) {
          const newUser: any = task.user;
          const primaryRole = newUser.userRoles?.[0];
          if (primaryRole) {
            const role = this.roles.find(r => r.id === primaryRole.roleid);
            primaryRole.roleName = role?.name ?? primaryRole.roleName;
          }
          newUser.status = thisTaskStatus;
          this.Users.push(newUser);
        } else if (task.userStatusText != null) {
          existingUser.status = task.userStatusText;
        }
      });

      this.dataSource = new MatTableDataSource(this.Users);
      this.dataSource.sort = this.sort;
    }
  }

  RemoveUser(user: any) {
    //remove user from listing group
  }

  getOwnershipDetail(): void {
    this.loading = true;
    this.lookupService.apiV1LookupGetOwnershipAdditionalDocumentGet({ propertyListingId: this.selectedListing.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the ownership report."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: any) => {
        if (result && result.contractDetail) {
          if (result.contractDetail?.conveyancerDetail && result.contractDetail?.conveyancerDetail.contactPerson) {
            let newUser: any = this.createdTempUser(true, result.contractDetail);
            newUser.userRoles[0].roleName = this.roles.find(r => r.name === 'Network Conveyancer')?.name;
            newUser.status = "The Seller(s) wish to appoint their own conveyancer.";
            this.Users.push(newUser);
          }
          else {
            console.log("No conveyancer was added in sell your property process.");
          }

          if (result.contractDetail?.urbanPlannerDetail && result.contractDetail?.urbanPlannerDetail.name) {
            let newUser: any = this.createdTempUser(false, result.contractDetail);;
            newUser.userRoles[0].roleName = this.roles.find(r => r.name === 'Network Planner')?.name;
            newUser.status = "The Seller wish to appoint their own urban planner.";
            this.Users.push(newUser);
          } else {
            console.log("No urban planner was added in sell your property process.");
          }
        }
        this.dataSource = new MatTableDataSource(this.Users);
        this.dataSource.sort = this.sort;
      });
  }

  createdTempUser(Isconveyancer: boolean, contractDetail: ContractDetailDto): UserDto {
    if (Isconveyancer == true) {
      return {
        createdBy: null,
        createdDate: null,
        endorsed: false,
        idNumber: null,
        isDeleted: false,
        confirmEmail: contractDetail.conveyancerDetail?.emailAddress ?? "",
        email: contractDetail.conveyancerDetail?.emailAddress ?? "",
        id: contractDetail.conveyancerDetail?.id ?? "",
        userType: "conveyancer",
        confirmMobile: contractDetail.conveyancerDetail?.mobileNumber ?? "",
        mobile: contractDetail.conveyancerDetail?.mobileNumber ?? "",
        name: contractDetail.conveyancerDetail?.contactPerson ?? "",
        surname: contractDetail?.urbanPlannerDetail?.surname ?? "",
        userRoles: [{ id: undefined, isDeleted: false, roleid: undefined, roleName: undefined, userid: undefined }]
      }
    } else {
      return {
        createdBy: null,
        createdDate: null,
        endorsed: false,
        idNumber: null,
        isDeleted: false,
        confirmEmail: contractDetail.urbanPlannerDetail?.email ?? "",
        email: contractDetail?.urbanPlannerDetail?.email ?? "",
        id: contractDetail?.urbanPlannerDetail?.id ?? "",
        userType: "urban-planner",
        confirmMobile: contractDetail?.urbanPlannerDetail?.phone ?? "",
        mobile: contractDetail?.urbanPlannerDetail?.phone ?? "",
        name: contractDetail?.urbanPlannerDetail?.name ?? "",
        surname: contractDetail?.urbanPlannerDetail?.surname ?? "",
        userRoles: [{ id: undefined, isDeleted: false, roleid: undefined, roleName: undefined, userid: undefined }]
      }
    }
  }

  private addAgentCreated(propertyListingDto: PropertyListingDto): void {
    if (propertyListingDto.createdBy) {
      this.loading = true;
      this.userManagementService.apiV1UserManagementGetCurrentUserByIdGet({ id: propertyListingDto.createdBy })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Error getting the ownership report."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((agent: UserDto | void) => {
          if (agent) {
            let hasAgentRole: boolean = agent.userRoles.some(ur => ur.roleName == "Network Agent" || ur.roleName == "Principal Agent");
            if (hasAgentRole == true) {
              let newUser: any = agent;
              newUser.status = "Agent created the property listing in sell your property process.";
              this.Users.push(agent);
            } else {
              this.notificationService.showWarningMessage("Warning", "This listing was not created by a user with agent roles.");
              let newUser: any = agent;
              newUser.status = "Agent created the property listing in sell your property process.";
              this.Users.push(agent);
            }
          } else {
            this.notificationService.showErrorMessage("Error", "Could not get agent that created listing.");
          }
        });
    }
  }
}
